import { render, staticRenderFns } from "./EmpresaBlocoInformacaoSkeleton.vue?vue&type=template&id=2d08058c&scoped=true&lang=pug"
import script from "./EmpresaBlocoInformacaoSkeleton.vue?vue&type=script&lang=js"
export * from "./EmpresaBlocoInformacaoSkeleton.vue?vue&type=script&lang=js"
import style0 from "./EmpresaBlocoInformacaoSkeleton.vue?vue&type=style&index=0&id=2d08058c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08058c",
  null
  
)

export default component.exports